import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { apiGet } from "../../lib/api";

type Message = {
  id: number;
  title: string;
  body: string;
  channels: string;
  target_type: string;
  recipient_count: number;
  push_total: number;
  push_sent: number;
  push_received: number;
  sms_total: number;
  sms_sent: number;
  email_total: number;
  email_sent: number;
  created_at: string;
  dispatched_at: string | null;
  scheduled_at: string | null;
};

export default function AdminMessages() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["messages"],
    queryFn: () => apiGet<{ items: Message[] }>("/api/admin/messages"),
  });

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Zprávy</h1>
        <Link to="/admin/messages/new">
          <button type="button">+ Nová zpráva</button>
        </Link>
      </div>

      {isLoading && <p>Načítám…</p>}
      {data && (
        <table>
          <thead>
            <tr>
              <th>Titulek</th>
              <th>Cíl</th>
              <th>Kanály</th>
              <th>Příjemců</th>
              <th>Doručeno</th>
              <th>Odesláno</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((m) => (
              <tr key={m.id} style={{ cursor: "pointer" }} onClick={() => navigate(`/admin/messages/${m.id}`)}>
                <td><Link to={`/admin/messages/${m.id}`}>{m.title}</Link></td>
                <td className="muted">{{ all: "Všichni", polygon: "Polygon", list: "Distribuční seznam", streets: "Ulice" }[m.target_type] ?? m.target_type}</td>
                <td className="muted">{JSON.parse(m.channels).map((ch: string) => ch === "push" ? "Aplikace" : ch.toUpperCase()).join(", ")}</td>
                <td>{m.recipient_count}</td>
                <td className="muted" style={{ whiteSpace: "nowrap" }}>
                  <DeliveryStats message={m} />
                </td>
                <td className="muted">
                  {m.dispatched_at
                    ? new Date(m.dispatched_at).toLocaleString("cs-CZ")
                    : m.scheduled_at
                      ? `Naplánováno: ${new Date(m.scheduled_at).toLocaleString("cs-CZ")}`
                      : "Čeká"}
                </td>
              </tr>
            ))}
            {data.items.length === 0 && (
              <tr>
                <td colSpan={6} className="muted" style={{ textAlign: "center" }}>
                  Zatím žádné zprávy
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

function DeliveryStats({ message: m }: { message: Message }) {
  const parts: string[] = [];
  if (m.push_total > 0) {
    const pushLabel = m.push_received > 0
      ? `Aplikace: ${m.push_received}✓ ${m.push_sent}/${m.push_total}`
      : `Aplikace: ${m.push_sent}/${m.push_total}`;
    parts.push(pushLabel);
  }
  if (m.sms_total > 0) parts.push(`SMS: ${m.sms_sent}/${m.sms_total}`);
  if (m.email_total > 0) parts.push(`Email: ${m.email_sent}/${m.email_total}`);
  return <>{parts.length > 0 ? parts.join("  ") : "—"}</>;
}
